import { useCallback, useEffect, useState } from 'react';

export default function useNextTick() {
  const [tick, setTick] = useState<{ fn: VoidFunction }>();

  useEffect(() => {
    if (typeof tick?.fn === 'function') tick.fn();
  }, [tick]);

  return useCallback(
    (func: VoidFunction) => {
      setTimeout(() => {
        setTick({ fn: func });
      });
    },
    [setTick],
  );
}
